module.exports = __webpack_public_path__ + "media/svg/mycorner-blanc-ad41b3ba.svg";